module.exports = __webpack_public_path__ + "img/partenaires.c1754543.png";